export default __webpack_public_path__ + "static/media/work.0ef4bab8.svg";